import { useState } from "react";
import { Button } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LayerSettings from "./LayerSettings";

export default function LayerSettingsButton(props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="navtools"
        aria-label="Layer-Einstellungen"
        onClick={() => {
          setOpen(!open);
        }}
        sx={(theme) => ({color: theme.palette.navigation.buttonColor,})}
      >
        <LayersOutlinedIcon
          sx={(theme) => ({
            color: open
              ? theme.palette.primary.main
              : theme.palette.navigation.buttonColor,
          })}
        />
      </Button>
      {/* {mapHook.map?.map.getZoom() >= 8 && ( */}
      <LayerSettings extended={open} setHeaderExtended={setOpen} />
      {/* )} */}
    </>
  );
}
